export const ACTIVE = 'active'
export const INACTIVE = 'inactive'

export const FILTER_NAME = 'container_type'
